/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemAnswerTextCorrectionSubGridItemRepositoryResponsePaginatedResponse } from "../types/ExamItemAnswerTextCorrectionSubGridItemRepositoryResponsePaginatedResponse.ts";
import { examItemAnswerTextCorrectionSubGridItemRepositoryResponseSchema } from "./examItemAnswerTextCorrectionSubGridItemRepositoryResponseSchema.ts";

export const examItemAnswerTextCorrectionSubGridItemRepositoryResponsePaginatedResponseSchema =
  z.object({
    data: z
      .array(
        z.lazy(
          () => examItemAnswerTextCorrectionSubGridItemRepositoryResponseSchema,
        ),
      )
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<ExamItemAnswerTextCorrectionSubGridItemRepositoryResponsePaginatedResponse>;
